
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { Physicals } from '../../canvas/entities/Physicals';
import { Stopwatch } from './Stopwatch';

export const stopwatchCreate = defineCommand(
    'stopwatchCreate',
    'Create: Stopwatch',
    r => Physicals.createAtCameraPosition(r, Stopwatch, sw => {
        sw.minutes = '05';
        sw.seconds = '00';
    })
);

export const inStopwatchCommands = () => inCommands(
    stopwatchCreate,
);

